import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { NewsroomStoryBlockTemplate } from "./story-block.templates";

/**
 * The story block uses the `ux-tab` component in conjunction with the `ux-slider` component.
 *
 * The content of the slides is the `ux-iws-teaser-story` component.
 *
 * Detailed integration example in the source code.
 */
export default {
    title: "Website/Partial Templates/Newsroom Blocks/Story Block (H.20)",
    render: NewsroomStoryBlockTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
    args: {
        tabs: [{ id: "neue-artikel", label: "Neue Artikel" }],
    },
};

export const SingleTab = {};

export const AllTabs = {
    args: {
        tabs: [
            { id: "neue-artikel", label: "Neue Artikel" },
            { id: "laser", label: "Laser" },
            { id: "industrie-4-0", label: "Industrie 4.0" },
            { id: "blech", label: "Blech" },
            { id: "zukunft", label: "Zukunft" },
            { id: "arbeitswelt", label: "Arbeitswelt" },
            { id: "meinung", label: "Meinung" },
        ],
    },
};
